import { Container } from "@mui/material";
import { useRef } from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import DevelopmentServiceBanner from "./Banner";
import ContactForm from "./ContactForm";
import Process from "./Process";
import OurReviews from "./Reviews";
import Services from "./Services";
import OurWork from "./Work";
import ChatFloatingBtn from "../../components/chatFloatingBtn";

const DevelopmentService = () => {
  const openChatBoxRef = useRef(null);

  return (
    <NavigationDrawer>
      <Container
        sx={{
          maxWidth: "1400px !important",
          marginTop: { xs: "120px", md: "80px" },
          alignItems: "center",
        }}
      >
        <DevelopmentServiceBanner />
        <Services />
        <OurWork />
        <Process />
        <OurReviews />
        <ContactForm openChatBoxRef={openChatBoxRef} />
      </Container>
      <ChatFloatingBtn openChatBoxRef={openChatBoxRef} />
    </NavigationDrawer>
  );
};

export default DevelopmentService;
